<template>

  <AppDataTable
    ref="navHistoryTable"
    :fields="fields"
    :end-point="'/scopes/'+scope_id+'/nav-status'"
  >

    <template #status="item">
      <div class="text-center">
        <i v-if="item.data === 'Success'" :class="[$getConst.icons.check, 'text-success  fa-2x']"/>
        <i v-else :class="[$getConst.icons.close, 'text-danger fa-2x']"/>
      </div>
    </template>

  </AppDataTable>
</template>

<script>
  import {getNavStatusHistory} from "../../../../api/scopes.api";
  import AppSpinner from "../../../../components/common/utils/AppSpinner";
  import AppDataTable from "../../../../components/common/table/AppDataTable";

  export default {
    name: "NavStatusHistory",
    components: {AppDataTable, AppSpinner},
    props: {
      scope_id: null
    },
    data() {
      return {
        isLoading: false,
        fields: [
          {
            key: 'created_at',
            label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_date),
            filterable: 'date'
          },
          { key: 'duration', label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_response_time) },
          {
            key: 'status',
            label: this.$t(this.$getConst.pages.nav_status_history.nav_status_test_result),
            filterable: true,
            formatter: (value, key, item) => {
              return value.toLowerCase() === "success"
            },
          },
        ]
      }
    },
    created() {
      this.fields[2].filterable = [
          { value: 'Success', text: "Success" },
          { value: 'Failed', text: "Failed" }
       ];
    }
  }
</script>

<style>
  tbody tr td:nth-child(3) {
    width: 18% !important;
  }
</style>
